var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcurement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Procurement_ico") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large_review",
    transform: "translate(-25.000000, -347.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Procurement_ico",
    transform: "translate(25.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,17.0503 L6.75,17.0503 C6.336,17.0503 6,17.3863 6,17.8003 L6,22.3003 C6,22.7143 6.336,23.0503 6.75,23.0503 L11.25,23.0503 C11.664,23.0503 12,22.7143 12,22.3003 L12,17.8003 C12,17.3863 11.664,17.0503 11.25,17.0503 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25,17.0503 L12.75,17.0503 C12.336,17.0503 12,17.3863 12,17.8003 L12,22.3003 C12,22.7143 12.336,23.0503 12.75,23.0503 L17.25,23.0503 C17.664,23.0503 18,22.7143 18,22.3003 L18,17.8003 C18,17.3863 17.664,17.0503 17.25,17.0503 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25,11.0503 L9.75,11.0503 C9.336,11.0503 9,11.3863 9,11.8003 L9,16.3003 C9,16.7143 9.336,17.0503 9.75,17.0503 L14.25,17.0503 C14.664,17.0503 15,16.7143 15,16.3003 L15,11.8003 C15,11.3863 14.664,11.0503 14.25,11.0503 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25,23.0503 L23.25,7.4493 C23.25,6.8963 22.945,6.3873 22.456,6.1263 L12.706,0.9263 C12.265,0.6913 11.735,0.6913 11.294,0.9263 L1.544,6.1263 C1.055,6.3873 0.75,6.8963 0.75,7.4493 L0.75,23.0503",
    id: "Stroke-7"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcurement);
export default __webpack_public_path__ + "static/media/procurement.fd46003dc2cacf1b3d9993df6df24d1b.svg";
export { ForwardRef as ReactComponent };